import { render, staticRenderFns } from "./show-schedule-block.vue?vue&type=template&id=2724892d&scoped=true"
import script from "./show-schedule-block.vue?vue&type=script&setup=true&lang=js"
export * from "./show-schedule-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./show-schedule-block.vue?vue&type=style&index=0&id=2724892d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724892d",
  null
  
)

export default component.exports